import React from "react";

import HomeHero from "./HomeHero";

import HomeContent from "./HomeContent";
import Seo, {
  organizationSchema,
  privateLabelServiceSchema,
  websiteSchema,
} from "../Seo/Seo";

function Home() {
  return (
    <>
    <Seo
      title="Private Label Laundry Detergent Sheets Manufacturer | Klean Leaf"
      description="Launch private label laundry detergent sheets with Klean Leaf. Get custom formula, scent, packaging, wholesale production, samples, and logistics support."
      path="/"
      schema={[
        organizationSchema,
        websiteSchema,
        privateLabelServiceSchema,
      ]}
    />
    <HomeHero />
    <HomeContent />
    </>
  );
}

export default Home;
